import { useQuery } from "@tanstack/react-query";
import { customInstance } from "~/custom-instance";

export type BoundingBoxMatch = {
  box_2d: [number, number, number, number];
};

export type TextBoundingBoxesResponse = {
  matches: BoundingBoxMatch[];
  query: string;
  pageId: string;
};

type GetTextBoundingBoxesParams = {
  organizationId: string;
  projectId: string;
  pageId: string;
  query: string;
};

const getTextBoundingBoxes = async ({
  organizationId,
  projectId,
  pageId,
  query,
}: GetTextBoundingBoxesParams): Promise<TextBoundingBoxesResponse> => {
  const baseUrl = import.meta.env.VITE_BASE_API_URL;
  return customInstance<TextBoundingBoxesResponse>({
    url: `${baseUrl}/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/text-bounding-boxes`,
    method: "post",
    data: { query },
  });
};

export const useTextBoundingBoxes = (
  organizationId: string | undefined,
  projectId: string | undefined,
  pageId: string | undefined,
  query: string | null
) => {
  return useQuery({
    queryKey: ["textBoundingBoxes", organizationId, projectId, pageId, query],
    queryFn: () =>
      getTextBoundingBoxes({
        organizationId: organizationId!,
        projectId: projectId!,
        pageId: pageId!,
        query: query!,
      }),
    enabled:
      !!organizationId &&
      !!projectId &&
      !!pageId &&
      !!query &&
      query.trim().length > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
